import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/stories';

export async function query(args: any): Promise<any> {
	const url: URL = new URL(rootUrl);

	url.searchParams.append('offset', String(0));
	url.searchParams.append('amount', String(args.amount));

	if (args.dateFrom) url.searchParams.append('dateFrom', args.dateFrom);
	if (args.dateTo) url.searchParams.append('dateTo', args.dateTo);

	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function get(id: number): Promise<any> {
	const response: Response = await BBApi.get(`${rootUrl}/${id}`);
	const json: any = await response.json();
	return json;
}

export async function create(story: any): Promise<any> {
	throw new Error('Not implemented');
}

export async function update(id: number, story: any): Promise<void> {
	throw new Error('Not implemented');
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented');
}
